module.exports = __webpack_public_path__ + "img/744.69742539.jpg";